<div>
  <app-vct-from-filter *ngIf="years"
    [years]="years"
    (search)="searchData($event)">
  </app-vct-from-filter>
  <mat-divider></mat-divider>
  <app-vct-from-bar-chart
    [title]="text"
    [subtitle]="subtitle"
    [displayUnits]="displayUnits"
    [data]="data">
  </app-vct-from-bar-chart>
</div>
